<script setup>
/** 面包屑 */
defineProps({
  size: { type: String, default: null },
  loading: { type: Boolean, default: false },
  separator: { type: String, default: '/' },
  breadcrumbs: {
    type: Array,
    default: () => []
  }
})
</script>

<template>
  <nav class="tvb-breadcrumbs" :class="size ? 'breadcrumbs-' + size : ''">
    <div v-if="loading" class="tvb-skeleton tvb-breadcrumb__skeleton" style="width: 12%"></div>
    <template v-else>
      <component
        v-for="(breadcrumb, index) in breadcrumbs"
        :to="breadcrumb.path"
        :key="index"
        :is="breadcrumb.path ? 'tvb-router-link' : 'span'"
        class="tvb-breadcrumb"
      >
        <span :class="{ separator: index }" v-if="breadcrumb.name">{{
          index ? `${separator}` : ''
        }}</span>
        <h5 class="clear-h" :title="breadcrumb.name">
          <span>{{ breadcrumb.name }}</span>
        </h5>
      </component>
    </template>
  </nav>
</template>

<style lang="scss" scoped>
.tvb-breadcrumbs {
  display: flex;
  align-items: center;
  --tvb-breadcrumb-color: #666;
  // TC-1481：当前项（最后一级）颜色对齐设计稿 #1c191a（原 #231f20）
  --tvb-breadcrumb-active-color: #1c191a;
  --tvb-breadcrumb-fs: 14px;
  --tvb-breadcrumb-lh: 20px;
  --tvb-breadcrumb-ls: 0.3px;
  // 分隔符两侧间距 8px（即项间 gap 8px）
  --tvb-breadcrumb-left: 8px;
  color: var(--tvb-breadcrumb-color);
  font-size: var(--tvb-breadcrumb-fs);
  line-height: var(--tvb-breadcrumb-lh);
  letter-spacing: var(--tvb-breadcrumb-ls);

  // TC-1481：移动端（<768px）面包屑高度 30px
  // 用 min-height 防止极端长文案换行时被裁切，正常单行时视觉高度即为 30px
  @media (max-width: 767px) {
    min-height: 30px;
  }

  a {
    text-decoration: none;
    background-color: transparent;
    color: inherit;
    cursor: pointer;
    &:visited {
      color: inherit;
    }
  }

  .tvb-breadcrumb {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    > h5 {
      display: inline-block;

      &:hover {
        color: #231f20;
        transition: all 0.15s linear;
      }
    }
    &:last-child {
      flex-shrink: 1;
      > h5 {
        color: var(--tvb-breadcrumb-active-color);
        @include line-text-ellipsis(1);
      }
    }
    .separator {
      padding: 0 var(--tvb-breadcrumb-left);
    }
  }

  &.breadcrumbs-s,
  &.breadcrumbs-xs {
    // TC-1481：移动端项间 gap 统一为 8px（原 6px），对齐设计稿
    --tvb-breadcrumb-left: 8px;
  }

  .tvb-breadcrumb__skeleton {
    height: var(--tvb-breadcrumb-lh);
  }
}
</style>
